import React, {Dispatch} from 'react'

import {AppDispatch} from 'store'
import {NinchatProperties} from '../../../api/types'
import {NinchatStoreMessage} from 'api/types/store'
import {NinchatUserQueue} from 'api/types/properties'
import {ScrollToBottomProps} from '../../ScrollToBottom/types'
import {TFunction} from 'i18next'

export interface MessagesProps {
    chat: NinchatProperties.Chat
    isAudienceChannel?: boolean
    isNarrow?: boolean
    messagesContainerRef?: React.MutableRefObject<HTMLDivElement | undefined | null>
    setHistoryLoadStatus?: Dispatch<boolean>
    setScrollToBottomView?: (visibility: ScrollToBottomProps) => void
    queueId?: NinchatProperties.QueueID
}

export type MessageProps = NinchatStoreMessage & {customText?: string, skipTime?: boolean, renderAsMarkdown?: boolean}

export type MessagesViewProps = {
    bottomElementSetRef: Dispatch<HTMLDivElement>
    currentQueue: NinchatUserQueue | null
    isAudienceChannel?: boolean
    isChannel?: boolean
    isNarrow?: boolean
    messages?: MessageProps[]
    onAction: (action: MessageActionTypes, message: MessageProps) => void
    onDeleteMessage: (messageId: string) => void
    onRemovePendingMessage: (messageId: string) => void
    onRetryMessage: (message: MessageProps) => void
    topElementSetRef: Dispatch<HTMLDivElement>
    channelId?: string
}

export type MessageRights = 'other' | 'moderatorOperator'

export interface ChannelMessageProps {
    channelId?: string,
    iconUrl: string,
    isLast?: boolean,
    isMe: boolean,
    isRepeated: boolean,
    isWriting?: boolean,
    message: MessageProps,
    time: string,
    rights?: MessageRights
    onRemovePendingMessage?: (messageId: string) => void
    onRetryMessage?: (message: MessageProps) => void
}

export interface DeletedMessageProps {
    isMe: boolean,
    rights?: MessageRights

}

export interface InfoMessageProps {
    message: MessageProps,
    time: string
}

export type UIMessageProps = ChannelMessageProps

export interface AccessMessageProps {
    isMe: boolean,
    isRepeated: boolean,
    message: MessageProps,
    time: string
    iconUrl: string,
    rights: MessageRights
}

export interface MetadataMessageProps {
    channelId: string,
    currentQueue?: NinchatUserQueue | null,
    isMe: boolean,
    message: MessageProps,
    time: string,
    rights: MessageRights
}

export enum MessageActionTypes {
    unsilence = 'unsilence',
    silence = 'silence',
    silence5m = 'silence_5m',
    silence15m = 'silence15m',
    silence1h = 'silence1h',
    silence24h = 'silence24h',
    showMessage = 'showMessage',
    hideMessage = 'hideMessage',
    hideAllMessages = 'hideAllMessages',
    showNewMessages = 'showNewMessages',
    hideNewMessages = 'hideNewMessages',
    removeUser = 'removeUser'
}

export interface MessageActionProps {
    action: MessageActionTypes
    channelId: string,
    message: Partial<MessageProps>
    dispatch: AppDispatch
    t: TFunction
}
